export const URL_SERVICIOS = 'https://peopletalent.edrum.com.mx:8000';
// export const URL_SERVICIOS = 'http://127.0.0.1:3000';
